import { initLazyLoad } from '../../../../../../modules/Util/F/Function/lazyload.js';

initLazyLoad();
